import UserIcon from '@assets/icons/UserIcon';
import AvatarHandler from '@components/Global/AvatarHandler/AvatarHandler';
import AppSelect from '@components/Global/select';
import { AntDesign, Feather } from '@expo/vector-icons';
import toTitleCase from '@hooks/toTitleCase';
import styles from '@stylesheet';
import React, { useEffect, useState } from 'react';
import { View, Text, Image, ImageStyle, ViewStyle, Platform, Pressable } from 'react-native';
import * as Animatable from 'react-native-animatable';
import { SizableText, XStack, YStack } from 'tamagui';
import { Badge } from '@constants/Themed'

interface UserListItemProps {
  item: string | { id: string, name: string, surname: string, email: string, avatar: string | { img: string } };
  index?: number;
  filterUser?: (id: string) => void;
  row?: boolean;
  removePermission?: boolean;
  textColor?: string;
  hideEmail?: boolean;
  avatarImageStyle?: ImageStyle;
  inverse?: boolean;
  hideDetails?: boolean;
  containerStyle?: ViewStyle;
  size?: 'large' | 'small';
  theme?: boolean;
}

const UserListItem = ({
  size,
  containerStyle,
  hideDetails,
  inverse,
  avatarImageStyle,
  hideEmail = false,
  item,
  textColor,
  index,
  row,
  removePermission = false,
  filterUser,
  theme = true
}: UserListItemProps) => {

  const [userItem, setUserItem] = useState(() => (typeof item === "object" ? item : null));
  const [value, setValue] = useState('');
  const items = [
    { label: 'Admin', value: 'admin' },
    { label: 'Common', value: 'common' }
  ];

  useEffect(() => {
    if (typeof item === "object") {
      setUserItem({
        ...(item.profile_information || {}),
        ...item
      });
    }
  }, [item]);

  if (!item || item === 'localhost' || item === 'web') {
    return (
      <Animatable.View useNativeDriver animation="bounceIn" style={{ flexDirection: row ? (inverse ? "column-reverse" : "column") : (inverse ? "row-reverse" : "row"), gap: 10, flex: 1, marginVertical: 10, ...containerStyle }}>
        <Image
          source={require('@assets/icons/cloud-connection.svg')}
          style={[
            styles.centerEverything,
            {
              aspectRatio: 1,
              borderColor: "white",
              width: 50,
              height: 50,
              borderRadius: avatarImageStyle?.width ? avatarImageStyle?.width / 2 : 50
            },
            avatarImageStyle
          ]}
        />
      </Animatable.View>
    );
  }

  const userId = typeof item === 'object' ? (item.id || item.value || item._id) : item;

  return (
    <Animatable.View 
      useNativeDriver
      animation="fadeInUp"
      duration={500}
      delay={(index || 0) * 50}
      style={{
        flexDirection: row ? (inverse ? "column-reverse" : "column") : (inverse ? "row-reverse" : "row"),
        marginVertical: 6,
        ...containerStyle
      }}
    >
      <View style={{
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: theme ? '#ffffff' : '#1e293b',
        borderRadius: 16,
        padding: 12,
        borderWidth: 1,
        borderColor: theme ? '#e2e8f0' : '#334155',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 4,
        elevation: 2,
        flex: 1
      }}>
        <AvatarHandler
          avatar={userItem?.avatar}
          avatarImageStyle={{
            width: 48,
            height: 48,
            borderRadius: 24,
            ...avatarImageStyle
          }}
          replacementImageStyle={{
            width: 48,
            height: 48,
            borderRadius: 24
          }}
        />
        
        {item?.count && (
          <View style={{ 
            position: 'absolute', 
            left: 45, 
            top: 10, 
            backgroundColor: '#ef4444', 
            borderRadius: 10, 
            minWidth: 20, 
            height: 20, 
            alignItems: 'center', 
            justifyContent: 'center',
            borderWidth: 2,
            borderColor: theme ? 'white' : '#1e293b'
          }}>
            <Text style={{ color: 'white', fontSize: 10, fontWeight: 'bold' }}>{item.count}</Text>
          </View>
        )}

        <View style={{ flex: 1, marginLeft: 12, justifyContent: 'center' }}>
          {!hideDetails && (
            <YStack>
              <Text style={{ 
                fontSize: size === 'large' ? 18 : 15, 
                fontWeight: '600', 
                color: textColor || (theme ? '#1e293b' : '#f8fafc') 
              }}>
                {toTitleCase(userItem?.name) || `Inviting: ${userItem?.email}`} {toTitleCase(userItem?.surname) || ""}
              </Text>
              {!hideEmail && userItem?.email && (
                <Text style={{ 
                  fontSize: 13, 
                  color: theme ? '#64748b' : '#94a3b8',
                  marginTop: 2
                }}>
                  {userItem.email}
                </Text>
              )}
            </YStack>
          )}
        </View>

        {!removePermission && (
          <View style={{ width: 100, marginRight: 8 }}>
            <AppSelect
              value={value}
              onValueChange={setValue}
              options={items}
              placeholder="Role"
              size="compact"
              minWidth={0}
              style={{ width: '100%' }}
            />
          </View>
        )}

        {filterUser && (
          <Pressable 
            onPress={() => filterUser(userId)}
            style={({ pressed }) => ({
              padding: 8,
              opacity: pressed ? 0.6 : 1
            })}
          >
            <Feather name="x" size={20} color={theme ? '#94a3b8' : '#64748b'} />
          </Pressable>
        )}
      </View>
    </Animatable.View>
  );
};

export default UserListItem;
